<!-- Our mission: to advance DataVis across the life sciences -->
<!-- </AddTweets> -->

<template>
  <ReplaceTweets>
    <div class="page-heading">
      <h3>About VIZBI</h3>
      <a href="/one-pager">
        <ButtonBespoke :outstanding="true">VIZBI One-Pager</ButtonBespoke>
      </a>
    </div>

    <p>
      Visualization is increasingly important in the life sciences as data grows rapidly in volume
      and complexity. VIZBI is an international community initiative bringing together researchers
      developing and using computational visualization across a broad range of biological research
      areas, alongside medical illustrators, graphic designers, and graphic artists. The
      initiative is centred on an annual VIZBI conference, whose core event is a three-day
      <router-link to="/">Workshop</router-link>, typically combined with a one-day
      <router-link to="/Masterclass">Data Visualization Masterclass</router-link>.
    </p>
    <p>
      To help the broader research community benefit from VIZBI,
      <router-link to="/Videos">videos</router-link> and slides from talks at previous meetings
      are available, as are <router-link to="/Posters">posters</router-link>. The VIZBI community
      has also produced a
      <a href="https://www.nature.com/nmeth/volumes/7/issues/3">special issue of Nature Methods</a>,
      with reviews providing practical guidance on methods and tools for visualizing biological
      data.
    </p>
    <p>
      VIZBI conferences also typically include an evening
      <router-link to="/Showcases">VIZBI Showcase</router-link>, a public-facing event exploring
      how visualization, animation, and art can communicate the life sciences to wider audiences.
      The community also organizes additional Showcase events beyond the annual conference. This
      public-engagement work grew from the
      <router-link to="/Plus">VIZBI Plus project</router-link> and continues through initiatives
      including the <router-link to="/Collective">VIZBI Collective</router-link>.
    </p>
    <!-- only need to show below if consent is not yet given -->
    <p v-if="consent">
      By using this site, you consent to our
      <router-link to="/Terms" @click.stop.prevent>cookie policy</router-link>.
    </p>
  </ReplaceTweets>
</template>

<script setup>
// import AddTweets from "@/components/AddTweets.vue";
import ButtonBespoke from "@/components/ButtonBespoke";
import ReplaceTweets from "@/components/ReplaceTweets.vue";
import {ref} from "vue";
const consent = ref(localStorage.GdprConsent || false);
</script>

<style scoped>
.page-heading {
  display: flex;
  flex-direction: row;
  justify-content: space-between; /* horizontal organization */
  align-items: center; /* optional, vertical centering */
}
h3 {
  display: inline;
}
i {
  font-weight: lighter !important;
}
</style>
